export interface TaxItem {
  name: string
  amount: number
}
export interface Discount {
  amount: number
  percentage?: number
}
export type GiftCardBalance = number
export type Change = number
export type Currency = string
export interface LineItemPromotion {
  name: string
  amount: number
  percentage?: number
}
export enum CFDEvents {
  SALE_UPDATED = 'SALE_UPDATED',
  SALE_HIDDEN = 'SALE_HIDDEN',
  SALE_COMPLETED = 'SALE_COMPLETED',
  SALE_PAYMENT_RECEIVED = 'SALE_PAYMENT_RECEIVED',
}
export type CFDEventSaleUpdated = CFDEvents.SALE_UPDATED
export type CFDEventSaleHidden = CFDEvents.SALE_HIDDEN
export type CFDEventSaleCompleted = CFDEvents.SALE_COMPLETED
export type CFDEventSalePaymentReceived = CFDEvents.SALE_PAYMENT_RECEIVED
export interface LineItem {
  id: string
  name: string
  variantName?: string
  quantity: number
  unitPrice: number
  basePrice: number
  finalPrice: number
  fulfillmentType?: 'DELIVERY' | 'PICKUP'
  promotion?: LineItemPromotion
  isRefund?: boolean
}
export interface SaleCompletedEvent {
  timestamp: string
  version: number
  type: CFDEventSaleCompleted
  data: SaleCompletedData
}
export interface SaleHiddenEvent {
  timestamp: string
  version: number
  type: CFDEventSaleHidden
}
export interface SalePaymentReceivedEvent {
  timestamp: string
  version: number
  type: CFDEventSalePaymentReceived
  data: SalePaymentReceivedData
}
export type SaleCompletedData = SalePaymentReceivedOrCompletedData
export type SalePaymentReceivedData = SalePaymentReceivedOrCompletedData
export interface SalePaymentReceivedOrCompletedData {
  paymentType: string
  currency: Currency
  discount?: Discount
  change?: Change
  giftCardBalance?: GiftCardBalance
  hasRefunds?: boolean
  showSuccess?: boolean
  lastPaymentAmount?: number
}
export interface SaleUpdatedEvent {
  timestamp: string
  version: number
  type: CFDEventSaleUpdated
  data: SaleData
}
export interface SaleData {
  lineItems: LineItem[]
  currency: string
  subTotal: number
  discount?: Discount
  tax: number
  taxes: TaxItem[]
  accountPayment?: number
  total: number
  balancePaid?: number
  balanceOutstanding?: number
  hasRefunds?: boolean
}
